/** Category ids whose conventional display form isn't plain capitalization (e.g. an acronym). */
const LABEL_OVERRIDES: Readonly<Record<string, string>> = { sfx: "SFX" };

/** Formats an `AssetCategory` id (e.g. `"palettes"`) as a display label (`"Palettes"`) for the `/assets` sidebar. */
export function formatCategoryLabel(category: string): string {
  return LABEL_OVERRIDES[category] ?? category.charAt(0).toUpperCase() + category.slice(1);
}
